import { ComponentStyleConfig } from '@chakra-ui/react';

const Progress: ComponentStyleConfig = {
  defaultProps: {
    colorScheme: 'primary',
    size: 'sm',
  },
};

export default Progress;
